import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class PimsPoListItem extends SearchModelBase {
    id: number = 0;
    pimsPoId: number = 0;
    pimsNo: string = '';
    pono: string = '';
    projectId: string = '';
    custRefNo: string = '';
    poDate: string | null = null;
    fromPoDate: string | null = null;
    toPoDate: string | null = null;
    customer: string = '';
    supplier: string = '';
    commodity: string = '';
    totQty: number | null = null;
    fromTotQty: number | null = null;
    toTotQty: number | null = null;
    reqDeliveryDate: string | null = null;
    fromReqDeliveryDate: string | null = null;
    toReqDeliveryDate: string | null = null;
    createdBy: string = '';
    pkgUnit: string = '';
    sellerName: string = '';
    sellerAddress: string = '';
    doordeliveryname: string = '';
    weight: number | null = null;
    volume: number | null = null;
    originAgentId: number | null = null;
    destAgentId: number | null = null;
    createdAt: string = '';
    status: string = '';
    pimsID1: string = '';
    pimsID2: string = '';
    pimsID3: string = '';
    pimsUserID: string = '';
    isAir: boolean = false;
    isOcean: boolean = false;
    isImport: boolean = false;
    isExport: boolean = false;
    isMy: boolean = false;
    isAll: boolean = false;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'Shipment ID', width: 120, dataIndex: 'pimsNo' }),
        XCol.Create({ col: 2, text: 'S/O #', width: 120, dataIndex: 'pono', defaultColumnFocus : true }),
        XCol.Create({ col: 3, text: 'S/O Date', width: 75, dataIndex: 'poDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy' }),
        XCol.Create({ col: 4, text: 'Project ID', width: 100, dataIndex: 'projectId' }),
        XCol.Create({ col: 5, text: 'Cust. Ref. #', width: 100, dataIndex: 'custRefNo' }),
        XCol.Create({ col: 6, text: 'Customer', width: 120, dataIndex: 'customer' }),
        XCol.Create({ col: 7, text: 'Supplier', width: 120, dataIndex: 'supplier' }),
        XCol.Create({ col: 8, text: 'Commodity', width: 120, dataIndex: 'commodity' }),
        XCol.Create({ col: 9, text: 'Qty', width: 80, dataIndex: 'totQty', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Req Arrival', width: 75, dataIndex: 'reqDeliveryDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, formatString: 'MM/dd/yyyy' }),
        XCol.Create({ col: 11, text: 'Create By', width: 100, dataIndex: 'createdBy' }),
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };

    public static OrderBy = { orderBy: PimsPoListItem.prototype.id, orderByAscending: false };

    public static formatData(data: PimsPoListItem[]) {
        return data.map((d: PimsPoListItem) => ({
            ...d,
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
        totQty: { from: 'fromTotQty', to: 'toTotQty' },
        poDate: { from: 'fromPoDate', to: 'toPoDate' },
        reqDeliveryDate: { from: 'fromReqDeliveryDate', to: 'toReqDeliveryDate' },
    }
}
